<template>
  <div class="flow-configure-data-design"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="designInfo">
      <FlowConfigureDataDesignMain :flow-id="rowData.id"
                                   :flow-key="rowData.flowKey"
                                   :design-info="designInfo"
                                   @after-submit="onAfterSubmit"></FlowConfigureDataDesignMain>
    </template>
    <template v-else-if="!loading">
      <Hint type="error">
        <div>流程设计数据加载失败</div>
        <el-button size="mini" type="text" @click="loadDesignInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import FlowConfigureDataDesignMain from './main'
import Hint from '../../../../elements/Hint'
export default {
  name: 'FlowConfigureDataDesign',
  components: {
    FlowConfigureDataDesignMain,
    Hint
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      designInfo: null
    }
  },
  methods: {
    loadDesignInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/flow/configure/data/designInfo',
        method: 'post',
        data: this.$qs.stringify({
          flowId: this.rowData.id
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.designInfo = response.data.designInfo || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    onAfterSubmit () {
      this.$emit('hidePopoverAndRefresh')
    }
  },
  mounted () {
    this.loadDesignInfo()
  },
  watch: {
    visible (val) {
      if (val) {
        this.loadDesignInfo()
      }
    }
  }
}
</script>

<style lang="scss">
.flow-configure-data-design {
  height: 100%;
}
</style>
